// animations/slideFromRight.js
import { createAnimation } from '@ionic/vue';

export const slideInFromRight = (baseEl) => {
  const root = baseEl.shadowRoot;

  const backdropAnimation = createAnimation()
    .addElement(root.querySelector('ion-backdrop'))
    .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

  const wrapperAnimation = createAnimation()
    .addElement(root.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, transform: 'translateX(100%)', opacity: '0' },
      { offset: 1, transform: 'translateX(0%)', opacity: '1' },
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-out')
    .duration(300)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};

export const slideOutToRight = (baseEl) => {
  const root = baseEl.shadowRoot;

  const backdropAnimation = createAnimation()
    .addElement(root.querySelector('ion-backdrop'))
    .fromTo('opacity', 'var(--backdrop-opacity)', '0.0');

  const wrapperAnimation = createAnimation()
    .addElement(root.querySelector('.modal-wrapper'))
    .keyframes([
      { offset: 0, transform: 'translateX(0%)', opacity: '1' },
      { offset: 1, transform: 'translateX(100%)', opacity: '0' },
    ]);

  return createAnimation()
    .addElement(baseEl)
    .easing('ease-in')
    .duration(300)
    .addAnimation([backdropAnimation, wrapperAnimation]);
};
